<ol class="breadcrumbs">
  @for (item of items.slice(0, -1); track item.caption) {
  <li>
    <a [href]="item.url">
      <span>{{ item.caption }}</span>
    </a>
  </li>
  } @empty {
  <li>There are no items.</li>
  }

  <li>
    <span>{{ items.at(-1)?.caption }}</span>
  </li>
</ol>
